import type { Theme } from '@mui/material/styles';

export type StatusChipToken =
  | 'SUCCESS'
  | 'FAILED'
  | 'RUNNING'
  | 'PENDING'
  | 'WARNING'
  | 'YELLOW'
  | 'SKIPPED'
  | 'NO_STATUS';

export function getStatusChipColors(theme: Theme): Record<StatusChipToken, string> {
  const statusChip = theme.palette.statusChip;

  return {
    SUCCESS: statusChip?.success ?? theme.palette.success.main,
    FAILED: statusChip?.failed ?? theme.palette.error.main,
    RUNNING: statusChip?.running ?? theme.palette.info.main,
    PENDING: statusChip?.pending ?? theme.palette.warning.main,
    WARNING: statusChip?.warning ?? theme.palette.warning.main,
    YELLOW: statusChip?.yellow ?? '#ffd058',
    SKIPPED: statusChip?.skipped ?? theme.palette.secondary.main,
    NO_STATUS:
      statusChip?.noStatus ??
      (theme.palette.mode === 'dark'
        ? theme.palette.grey[700]
        : theme.palette.grey[300]),
  };
}

export function getStatusChipColor(theme: Theme, token: StatusChipToken): string {
  return getStatusChipColors(theme)[token];
}
